import { IncludeType } from '../../../common';
import { Group } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

/**
 * Fetches related products for a given group ID and locale.
 *
 * @param groupId - The ID of the group to fetch attributes for.
 * @param locale - The locale to use when fetching data.
 * @param includeType - Specifies the type of attributes to include (default is `IncludeType.Available`).
 * @returns A promise that resolves to an array of `Group`, or `null` if none exist.
 */
export const getRelatedProductsByGroup = async (
  groupId: number,
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<Group[] | null> => {
  try {
    const url = `/group/${groupId}/related?include=${encodeURIComponent(includeType)}&marketLocale=${encodeURIComponent(locale)}`;
    const response = await productCatalogueHttp.get<Group[]>(url);

    return response?.data ?? null;
  } catch (error) {
    console.error(`Failed to fetch family attributes for familyId: ${groupId}`, error);
    return null;
  }
};
